import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";

export default class MovieService {

    constructor() {
        this.environmentService = new EnvironmentService();
    }

    async GetShows() {
        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/show/overview",
            {
                headers: {
                    "Authorization": "bearer " + Cookies.get("access_token")
                },
                method: "GET"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }

    async GetShowSeasons(showUuid) {
        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/show/"+showUuid+"/seasons/overview",
            {
                headers: {
                    "Authorization": "bearer " + Cookies.get("access_token")
                },
                method: "GET"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }

    async GetSeasonEpisodes(seasonuuid) {
        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/show/seasons/"+seasonuuid+"/episode/overview",
            {
                headers: {
                    "Authorization": "bearer " + Cookies.get("access_token")
                },
                method: "GET"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async GetEpisodeDetail(episodeuuid) {
        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/show/episode/detail?episodeuuid=" + episodeuuid,
            {
                headers: {
                    "Authorization": "bearer " + Cookies.get("access_token")
                },
                method: "GET"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async GetEpisodeVariants(episodeuuid) {
        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/show/episode/variants?episodeuuid=" + episodeuuid,
            {
                headers: {
                    "Authorization": "bearer " + Cookies.get("access_token")
                },
                method: "GET"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }
}
